<template>
  <div class="service">
    <!-- 顶部提示banner -->
    <div class="page-heading" style="background-image: url('static/menhu/images/fw1.jpg')">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <h1 style="color: rgb(8, 40, 65);">开创高端门业品牌新时代</h1>
            <span style="color: rgb(8, 40, 65);">Creating a new era of high -end door industry brands</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 选购知识 -->
    <div class="simple-recent-projects filter-projects">
      <div class="container">
        <div class="row">
          <div class="col-lg-12" style="text-align: center">
            <div class="section-heading">
              <h2>选购知识</h2>
              <p>
                客户在选择门的时候，经常会遇到许多的问题，也会有很多的选择。那如何选择正确的门就是我们的职责，下面是我们选择铸铝门的3大原则</p>
            </div>
          </div>

        </div>
        <div class="row">
          <div v-for="(item,index) in yz_list" :key="index" class="col-lg-4">
            <div class="blog-post">
              <img :src="item.image" alt="">
              <div class="down-content">
                <p class="fwTitle">{{ item.title }}</p>
                <p v-html="item.context"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 保养维修 -->
    <div class="comp_jj" style="background-image: url('static/menhu/images/fw3.jpg')">
      <p class="comp_jj_title">维修保养</p>
      <p class="comp_jj_desc">
        铸铝门在使用过程中保养是很重要的，铸铝门作为高端别墅门，性能是很理想的，所以价格也不菲。在建造别墅或是家庭住房时相信会有越多的人选择铸铝门。因为铸铝门的本身材质的原因，它的保养显得极其重要，如果铸铝门表面的喷漆脱落的话，里面的电解板就会暴露出来，而电解板一旦与空气中的氧气接触就会发生氧化反应，导致锌铁合金锈化，影响门的美观和性能。
        华威铸铝门,铜铝门,别墅门保养铜铝门很重要的一点就是保护表面喷漆的完整性，避免必必要的磕碰和撞击。在平常的铸铝门保养上，可以用干毛巾对它进行擦拭。切忌使用含有破坏喷漆保护层的化学成分的洗涤剂来清洁，在开启和关闭铸铝门的时候需要缓慢，这样的举动可以在很大程度上避免铸铝门与其他东西的碰撞而导致表面保护层遭受破坏。
      </p>
    </div>

    <!-- 流程 -->
    <div class="lcDiv">
      <el-row :gutter="10">
        <el-col :sm="24" :md="12">
          <div class="lcItem">
            <i :class="lcData[0].icon+' lcItem_icon'"></i>
            <p class="lcItem_p">{{ lcData[0].name }}</p>
            <p class="lcItem_desc">{{ lcData[0].desc }}</p>
          </div>
        </el-col>
        <el-col :sm="24" :md="12">
          <div class="lcItem">
            <i :class="lcData[1].icon+' lcItem_icon'"></i>
            <p class="lcItem_p">{{ lcData[1].name }}</p>
            <p class="lcItem_desc">{{ lcData[1].desc }}</p>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :sm="24" :md="8">
          <div class="lcItem">
            <i :class="lcData[2].icon+' lcItem_icon'"></i>
            <p class="lcItem_p">{{ lcData[2].name }}</p>
            <p class="lcItem_desc">{{ lcData[2].desc }}</p>
          </div>
        </el-col>
        <el-col :sm="24" :md="8">
          <div class="lcItem">
            <i :class="lcData[3].icon+' lcItem_icon'"></i>
            <p class="lcItem_p">{{ lcData[3].name }}</p>
            <p class="lcItem_desc">{{ lcData[3].desc }}</p>
          </div>
        </el-col>
        <el-col :sm="24" :md="8">
          <div class="lcItem">
            <i :class="lcData[4].icon+' lcItem_icon'"></i>
            <p class="lcItem_p">{{ lcData[4].name }}</p>
            <p class="lcItem_desc">{{ lcData[4].desc }}</p>
          </div>
        </el-col>
      </el-row>
    </div>

  </div>
</template>

<script>
import 'element-ui/lib/theme-chalk/display.css';
export default {
  name: 'service',
  data() {
    return {
      yz_list: [
        {
          title: "配套的原则",
          context: "我们选择的铸铝门在款式、颜色、风格上都要与门框套、整个室内装修的风格、 颜色、花纹等协调搭配，才能产生完整统一的装饰效果，才能让我们的家达到一个美观的效果。",
          image: "static/menhu/images/fw2-1.jpg"
        },
        {
          title: "保证安全的原则",
          context: "无论是户门还是房门，都需要有较好的隔音、防盗、耐冲击的能力， 才能有使用的安全感。因此，要选择材料材质密实、结构坚固、使用安全的铸铝门。梵蒂斯铸铝门除了防盗外，还有防火、防爆、保温隔音、气密性强的特点。",
          image: "static/menhu/images/fw2-2.jpg"
        },
        {
          title: "持久耐用性的原则",
          context: "一个高档的铸铝门耐用度持久度也非常关键，梵蒂斯铸铝门的铸铝面板采用国际标准铝锭，进行抛丸抗氧化处理，然后进行纯聚脂喷塑，经过200度高温固化，具有超强的附着力、耐冲击性、耐侯性、耐腐蚀性和耐黄等功效。保证十年不变型，不氧化，不褪色。",
          image: "static/menhu/images/fw2-3.jpg"
        }
      ],
      lcData:[
        {
          name:"规范的售后服务及流程",
          desc:"公司拥有规范的售后服务及流程。 售后服务包含24小时电话服务、长期技术指导服务、定期走访、回访与关怀服务等。流程从客户问题登记到解决问题都要按照公司标准统一执行。",
          icon:"el-icon-s-operation"
        },
        {
          name:"客户问题24小时内回复",
          desc:"我们公司规定，所有客户问题，每个必须在24小时内答复。 无论是咨询问题还是售后问题，梵蒂斯客服都会在规定时间内答复。所以放心联系我们或者咨询您想了解的东西。",
          icon:"el-icon-phone-outline"
        },
        {
          name:"客服人员经过专业培训",
          desc:"公司的客服人员都要经过专业的客服培训。培训内容包含产品、包装、物流、行业知识以及终端服务。 提高客服人员的从业水平和职业素养有助于公司品牌形象的打造，进而为市场营造温馨的销售氛围。",
          icon:"el-icon-s-custom"
        },
        {
          name:"二对一服务模式",
          desc:"我们的售后服务是二对一的服务模式。 每一个客户都有一个专属的客服人员。 从设计、下单、售后服务都可进行实时沟通并在最短时间内得到解决，减少因沟通产生的客诉问题。",
          icon:"el-icon-medal"
        },
        {
          name:"全程跟单",
          desc:"所有的订单都有专业的客服人员和专业的ERP生产管理软件帮助您全称跟单。",
          icon:"el-icon-s-claim"
        }
      ]
    }
  }
}
</script>

<style scoped>
.fwTitle {
  color: #000;
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  line-height: 1.583;
  overflow: hidden;
  transition: color 0.4s cubic-bezier(.075, .82, .165, 1);
  -moz-transition: color 0.4s cubic-bezier(.075, .82, .165, 1);
  -ms-transition: color 0.4s cubic-bezier(.075, .82, .165, 1);
  -webkit-transition: color 0.4s cubic-bezier(.075, .82, .165, 1);
  -o-transition: color
}
.comp_jj{
  width: 100%;
  height: 96vh;
  background-repeat: no-repeat;
  box-sizing: border-box;
  padding-left: 10%;
  padding-top: 20%;
}
.comp_jj_title{
  font-size: 24px;
  color: #fff;
}
.comp_jj_desc{
  font-size: 14px;
  color: #fff;
  line-height: 2.15;
  margin-bottom: 50px;
  font-weight: 300;
  width: 70%;
}

.lcDiv{
  width: 100%;
  height: auto;
  box-sizing: border-box;
  padding-left: 10%;
  padding-right: 10%;
}

.lcItem{
  width: 100%;
  height: auto;
  box-sizing: border-box;
  background: #F4F4F4;
  padding: 60px 78px;
  text-align: center;
  margin-bottom: 15px;
}

.lcItem:hover p{
  color: white !important;
}
.lcItem:hover i{
  color: white !important;
}
.lcItem:hover{
  background-color: #0f3e68;
}

.lcItem_p{
  color: #000;
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  line-height: 1.583;
  overflow: hidden;
}
.lcItem_desc{
  color: #858585;
  font-size: 14px;
  line-height: 2.15;
  overflow: hidden;
  margin-top: 14px;
}
.lcItem_icon{
  font-size: 55px;
  color: rgba(8, 40, 65, 1);
}

@media only screen and (max-width: 800px) {

}
</style>



// WEBPACK FOOTER //
// src/components/views/service.vue